import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LanguageProvider } from './i18n/LanguageContext';
import './i18n/i18n';
import './index.css';
import { setupAxiosInterceptors } from './utils/axiosInterceptor';
import { initThemeVariables } from './styles/theme';

// Инициализируем перехватчики axios
setupAxiosInterceptors();

// Инициализация переменных темы
initThemeVariables();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);